import { QuestionAnswerMap } from '@care-portals/api-interfaces';

const metabolicTadalafilQuestions = [
  {
    field: 'metabolicTadalafil_contraindications',
    label:
      'Do you currently have, or have you ever experienced any of the following?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          value: 'MI (heart attack) within the last six months',
          key: 'mi_within_last_6_months'
        },
        {
          value:
            'Hypertrophic cardiomyopathy, Idiopathic Hypertrophic Subaortic Stenosis or uncontrolled heart failure',
          key: 'hypertrophic_cardiomyopathy_or_uncontrolled_hf'
        },
        {
          value:
            'A heart arrhythmia (such as atrial fibrillation or QT prolongation)',
          key: 'heart_arrhythmia_or_qt_prolongation'
        },
        {
          value: 'Stroke or brain hemorrhage within the last 12 months',
          key: 'stroke_or_brain_hemorrhage_within_last_12_months'
        },
        {
          value: 'Sickle cell anemia, Myeloma, Leukemia',
          key: 'sickle_cell_anemia_or_myeloma_or_leukemia'
        },
        {
          value: 'Retinitis pigmentosa or history of sudden vision loss',
          key: 'retinitis_pigmentosa_or_sudden_vision_loss'
        },
        { value: 'Pulmonary hypertension', key: 'pulmonary_hypertension' },
        {
          value:
            'For men, a marked curve or bend in the penis that interferes with sex, painful erections, foreskin that is too tight or painful',
          key: 'penile_curve_or_painful_erections_or_tight_foreskin'
        },
        { value: 'Gastrointestinal ulcers', key: 'gastrointestinal_ulcers' },
        {
          value: 'No, I have never had any of these conditions',
          key: 'none',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    field: 'metabolicTadalafil_cardiovascularSymptoms',
    label: 'Do you experience any of the following cardiovascular symptoms?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          value:
            'Chest pain or shortness of breath when climbing 2 flights of stairs or walking 4 blocks',
          key: 'chest_pain_or_sob_with_exertion'
        },
        {
          value: 'Chest pain or shortness of breath with sexual activity',
          key: 'chest_pain_or_sob_with_sexual_activity'
        },
        {
          value: 'Unexplained fainting or dizziness',
          key: 'unexplained_fainting_or_dizziness'
        },
        {
          value: 'Prolonged cramping of the legs with exercise',
          key: 'prolonged_leg_cramps_with_exercise'
        },
        { value: 'None of those', key: 'none', uncheckOthers: true }
      ]
    }
  },
  {
    field: 'metabolicTadalafil_illicitDrugUse',
    label: 'Do you use any of the following?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          value: 'Poppers or Rush (Amyl Nitrate or Butyl Nitrate)',
          key: 'poppers_or_rush'
        },
        { value: 'Cocaine', key: 'cocaine' },
        { value: 'Methamphetamine (crystal meth)', key: 'methamphetamine' },
        { value: 'Other', key: 'other' },
        { value: 'None of the above', key: 'none', uncheckOthers: true }
      ]
    }
  },
  {
    field: 'metabolicTadalafil_illicitDrugOtherDetails',
    label: 'Please provide further information',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'metabolicTadalafil_illicitDrugOtherDetails'
    }
  },
  {
    field: 'metabolicTadalafil_consent',
    label: 'Low-Dose Tadalafil Therapy Consent',
    type: 'select',
    educationalSlide: `You are requesting treatment with a phosphodiesterase type 5 (PDE5) inhibitor (tadalafil) as part of your treatment plan. Low-dose daily tadalafil may be used to support blood flow, which can contribute to improved exercise recovery and enhanced erectile function. By promoting vasodilation, tadalafil may help improve circulation to muscles and other tissues, which may aid in recovery and overall performance.

Potential Benefits:
- Improved blood flow and circulation
- Support for exercise recovery and muscle performance
- Improved erectile function
- Increased ability to achieve and maintain erections sufficient for sexual activity
- Potential improvement in confidence, quality of life, and sexual satisfaction

Potential Side Effects:
While tadalafil is generally well tolerated, side effects may occur. Although uncommon, some may require medical attention.

Common Side Effects:
- Headache
- Flushing
- Indigestion or upset stomach
- Nasal congestion
- Back or muscle pain

Less Common Side Effects:
- Dizziness or lightheadedness
- Vision changes (e.g., color tinge, blurred vision)
- Hearing changes (rare)

Serious Side Effects (require immediate medical attention):
- Prolonged erection lasting more than 4 hours (priapism)
- Sudden vision or hearing loss
- Severe dizziness, fainting, chest pain, or difficulty breathing
- Signs of an allergic reaction (rash, swelling, difficulty breathing)

Risks and Considerations:
- Blood Pressure Effects: Tadalafil can lower blood pressure. It must not be used with nitrates, as this combination can cause a dangerous drop in blood pressure. Caution is also advised when used with certain blood pressure medications or alpha-blockers.

- Cardiovascular Health: Sexual activity and vasodilation may place strain on the cardiovascular system. Patients with underlying heart conditions should discuss risks with their provider.

- Off-Label Use: Use of tadalafil for exercise recovery and performance support is considered off-label and is not specifically approved by the FDA for this purpose.

- Medication Interactions: Tadalafil may interact with other medications. It is important to disclose all current medications and supplements to your provider.

- Alcohol Use: Excessive alcohol intake may increase the risk of side effects such as dizziness or low blood pressure.

Monitoring and Follow-Up:
You may require follow-up to assess your response to treatment and monitor for side effects. Please notify your healthcare provider if you experience any concerning symptoms, including changes in vision, hearing, cardiovascular symptoms, or prolonged erections.

Consent Statement:
I acknowledge the potential benefits, risks, and side effects of treatment with tadalafil. I understand that use for exercise recovery is considered off-label. I agree to follow up as recommended and to notify my provider of any side effects or concerns while using this medication.`,
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'I have read the consent and I do NOT wish to move forward',
          class: 'option-decline',
          key: 'non_consent'
        },
        {
          value:
            'I have read the consent and understand the content, I wish to proceed',
          class: 'option-consent',
          key: 'consent'
        }
      ]
    }
  },
  {
    field: 'metabolicTadalafil_complete',
    isLast: true,
    label: `Thank you for completing this questionnaire, please select "Finish" to submit`,
    extras: { sendToBeluga: false },
    type: 'info',
    answer: {}
  },
  {
    class: 'ineligible',
    field: 'metabolicTadalafil_ineligible',
    label: "We're sorry you don't qualify",
    subLabel: "We're not able to prescribe for you today",
    extras: { sendToBeluga: false },
    reject: true,
    answer: {},
    type: 'info',
    isLast: true
  },
  {
    class: 'ineligible',
    field: 'metabolicTadalafil_didNotConsent',
    label: 'We need your consent to continue',
    subLabel:
      'You did not agree to the terms shown on the previous step. Without that consent, we cannot move forward with your visit or prescribe treatment.',
    extras: { sendToBeluga: false },
    reject: true,
    answer: {},
    type: 'info',
    isLast: true
  }
] as const;

const _type = metabolicTadalafilQuestions;
export type MetabolicTadalafilFieldAnswers = Partial<
  QuestionAnswerMap<typeof _type>
>;

export default metabolicTadalafilQuestions;

